import { Injectable } from '@angular/core'
import { NavigationStart, Router } from '@angular/router'
import {
  distinctUntilChanged,
  filter,
  map,
  Observable,
  ReplaySubject,
  takeUntil,
} from 'rxjs'

export type LoadingTuple<Key extends string> = [Key, string, boolean]

@Injectable({
  providedIn: 'root',
})
export class LoadingService<Key extends string = string> {
  private loading = new ReplaySubject<LoadingTuple<Key>>(1)

  constructor(private router: Router) {}

  start(key: Key, token?: string): void {
    this.loading.next([key, token, true])
  }

  stop(key: Key, token?: string): void {
    this.loading.next([key, token, false])
  }

  isLoading(path: string, token?: string): Observable<boolean> {
    return this.loading.pipe(
      filter((tuple) => tuple[0].startsWith(path)),
      filter((tuple) => (token ? tuple[1] === token : true)),
      map((tuple) => tuple[2]),
      distinctUntilChanged(),
      takeUntil(
        this.router.events.pipe(
          filter((event) => event instanceof NavigationStart),
        ),
      ),
    )
  }
}
